


































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import { AxiosResponse } from "axios";

import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import { IPagination, ITableParams, IVenue } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    NavigationTabs,
    AlertBox
  }
})
export default class EventVenues extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  private venues: Array<IVenue> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.venue_deleted === "true") {
        swal("Success!", "The venue was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getVenues(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.venue_deleted === "true") {
      swal("Success!", "The venue was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getVenues(() => {
      //
    });
    next();
  }

  private getVenues(successCallback: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.venues = [];
    const endpoint: string = this.$partnerEndpoint("venues");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          perPage: this.fetchParams.per_page,
          search: this.fetchParams.search,
          type: "external"
        }
      })
      .then((response: AxiosResponse) => {
        this.venues = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteVenue(venueId: number): void {
    if (this.loading || this.updating || venueId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The external venue will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint("venues/" + venueId);

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "EventVenues",
                query: { venue_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The venue was deleted.", "success");
                  this.getVenues(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete external venues.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
